<template>
    <div class="News-content" style="margin:0;width:100%">
    <div class="News-content-title">
      <h1>{{title}}</h1>
      <p>
        <span v-show="source">来源：{{source}} | </span>
        <span>时间：{{time | datefilter}}</span>
        <span v-show="hit"> | 浏览：{{hit}}</span>
      </p>
    </div>
    <div v-html="details.replace(/\n/g,'<br/>')"></div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      ContentInfo: {
        modifyTime:1585625178000
      },
    }
  },
  props: {
    title: String,
    source: String,
    time: Number,
    hit: String,
    details: String
  },
  filters:{
    datefilter:function(val){
      var date = new Date(val) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-'
      var D = date.getDate()<10?'0'+(date.getDate())+ ' ':date.getDate() + ' '
      var h = date.getHours()<10?'0'+(date.getHours())+ ':':date.getHours() + ':'
      var m = date.getMinutes()<10?'0'+(date.getUTCMinutes()) + ':':date.getMinutes() + ':'
      var s = date.getSeconds()<10?'0'+(date.getSeconds()):date.getSeconds()
      return Y+M+D+h+m+s
    }
  },
  created () {
  },
  methods:{
    
  }
}
</script>

<style lang="scss">
  .News-content{
    width: 1204px;
    // margin: 60px auto;
    .News-content-title{
        text-align: center;
        h1{
            font-size: 26px;
            line-height: 32px;
            color: #222222;
            padding:10px 0 8px 0 ;
            font-weight: bold;
        }
        p{
            font-size: 14px;
            line-height: 20px;
            color: #888888;
            padding-bottom: 60px;
        }
    }
    img{
        margin: 0 auto;
    }
}
</style>